// Document metadata is set explicitly here and nowhere else — never derived
// from the project or prompt name.
export const SITE_TITLE = 'Lentic — Assessment for AI-assisted work'
export const SITE_DESCRIPTION =
  'Lentic runs candidates through an instrumented task where the AI is provided but the source documents are withheld, then produces the auditable record of how each person exercised judgement.'
export const SITE_OG_IMAGE = 'https://cdn.magicpatterns.com/uploads/wc7gr9wntPD888sQ3UFAgA/image.png'

// Ripple mark — four open arcs stepping round into a spiral. Teal on transparent.
const FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g fill="none" stroke="#1B5E5E" stroke-width="2" stroke-linecap="round">
    <circle cx="16" cy="16" r="15" pathLength="360" stroke-dasharray="300 60" transform="rotate(-6 16 16)"/>
    <circle cx="16" cy="16" r="11.6" pathLength="360" stroke-dasharray="296 64" transform="rotate(-36 16 16)"/>
    <circle cx="16" cy="16" r="8.2" pathLength="360" stroke-dasharray="292 68" transform="rotate(-66 16 16)"/>
    <circle cx="16" cy="16" r="4.9" pathLength="360" stroke-dasharray="288 72" transform="rotate(-96 16 16)"/>
  </g>
  <circle cx="16" cy="16" r="2" fill="#1B5E5E"/>
</svg>`

function setMeta(selector: string, attribute: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(selector)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attribute, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setIcon(rel: string, href: string, type?: string) {
  document.head
    .querySelectorAll(`link[rel="${rel}"]`)
    .forEach((node) => node.parentElement?.removeChild(node))
  const link = document.createElement('link')
  link.setAttribute('rel', rel)
  if (type) link.setAttribute('type', type)
  link.setAttribute('href', href)
  document.head.appendChild(link)
}

export function applyDocumentMeta() {
  if (typeof document === 'undefined') return

  document.title = SITE_TITLE

  setMeta('meta[name="description"]', 'name', 'description', SITE_DESCRIPTION)

  setMeta('meta[property="og:title"]', 'property', 'og:title', SITE_TITLE)
  setMeta('meta[property="og:description"]', 'property', 'og:description', SITE_DESCRIPTION)
  setMeta('meta[property="og:image"]', 'property', 'og:image', SITE_OG_IMAGE)
  setMeta('meta[property="og:type"]', 'property', 'og:type', 'website')

  setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image')
  setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', SITE_TITLE)
  setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', SITE_DESCRIPTION)
  setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', SITE_OG_IMAGE)

  const favicon = `data:image/svg+xml,${encodeURIComponent(FAVICON_SVG)}`
  setIcon('icon', favicon, 'image/svg+xml')
  setIcon('shortcut icon', favicon, 'image/svg+xml')
  setIcon('apple-touch-icon', favicon)
}
